module.exports = __webpack_public_path__ + "static/media/task_detail_company.dec7164c.svg";